<template>
  <input class="input-group" type="text" :placeholder="placeholder" :value="value" @input="$emit('input', $event.target.value)" />
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
}
</script>
<style lang="less" scoped>
.input-group {
  background: #fff;
  border-radius: 10px;
  padding: 0 24px;
  font-size: 18px;
  line-height: 60px;
  height: 60px;
  color: rbga(0, 0, 0, 1);
  width: 100%;
  ::-webkit-input-placeholder {
    color: rgba(0, 0, 0, 0.4);
  }
  &:hover {
    box-shadow: 0 0 0 3px #A9e0ff inset;
  }
  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px #44c1ff inset;
  }
}
</style>